export enum ContractStatusesEnum {
  NEW = 'NEW',
  SIGNED = 'SIGNED',
  CANCELED = 'CANCELED',
  DELETED = 'DELETED',
}
